import { SVGProps } from 'react'

export const VerticalCourseUserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.02509 0C7.95667 0 8.8501 0.368749 9.50883 1.02513C10.1676 1.6815 10.5376 2.57174 10.5376 3.5C10.5376 4.42826 10.1676 5.3185 9.50883 5.97487C8.8501 6.63125 7.95667 7 7.02509 7C6.0935 7 5.20008 6.63125 4.54135 5.97487C3.88262 5.3185 3.51254 4.42826 3.51254 3.5C3.51254 2.57174 3.88262 1.6815 4.54135 1.02513C5.20008 0.368749 6.0935 0 7.02509 0ZM7.02509 14C7.02509 14 14.0502 14 14.0502 12.25C14.0502 10.15 10.6254 7.875 7.02509 7.875C3.42473 7.875 0 10.15 0 12.25C0 14 7.02509 14 7.02509 14Z"
      fill="#1A1E3D"
    />
  </svg>
)
